import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { CODES } from "../../../consts/codes";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ModalInfo = ({ title, responseData, onClose, open, close = true }) => {
  const { data, status } = responseData;

  const handleClose = () => {
    onClose();
  };

  let titleColor = "";
  if (status === CODES.COD_RESPONSE_HTTP_OK) {
    if (
      data?.responseStatus?.statusCode ===
        CODES.S_COD_RESPONSE_SUCCESS_REQUEST ||
      data?.responseCode === CODES.COD_RESPONSE_SUCCESS_REQUEST ||
      data?.responseCode === CODES.COD_RESPONSE_HTTP_OK ||
      data?.responseCode === CODES.COD_RESPONSE_HTTP_CREATED
    ) {
      titleColor = "success";
    } else {
      titleColor = "error";
    }
  } else if (status === CODES.COD_RESPONSE_HTTP_ERROR) {
    titleColor = "error";
  } else {
    titleColor = "warning";
  }

  const { t } = useTranslation();

  const DialogTitleContainer = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle {...other}>
        {children}
        {onClose && close ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  return (
    <div>
      <Dialog
        className="modal__notification"
        onClose={handleClose}
        open={open}
        aria-labelledby="customized-dialog-title"
      >
        <div style={{ padding: "2rem" }}>
          <DialogTitleContainer onClose={handleClose}>
            {/* <label className={classNameTitle}> */}
            {titleColor === "success" && (
              <TaskAltOutlinedIcon
                sx={{ color: "#60CC64", fontSize: "4rem" }}
              />
            )}

            {titleColor === "warning" && (
              <InfoOutlinedIcon sx={{ color: "#4dcafa", fontSize: "4rem" }} />
            )}

            {titleColor === "error" && (
              <WarningAmberOutlinedIcon
                sx={{ color: "#4dcafa", fontSize: "4rem" }}
              />
            )}
            {/* </label> */}
          </DialogTitleContainer>

          <DialogContent className="heading-secondary__md">
            {titleColor === "success" && (
              <label>
                {title ? title : t("App.validationMessages.success")}
              </label>
            )}

            {titleColor === "error" && (
              <label>{title ? title : t("App.validationMessages.error")}</label>
            )}

            {titleColor === "warning" && <label> {" " + title}</label>}
            <br />

            <p className="default-text_black">
              {data?.responseMessage?.message || data?.responseMessage}
            </p>
          </DialogContent>

          <DialogActions>
            <div>
              <Button
                variant="contained"
                className="modal-button-action"
                onClick={handleClose}
              >
                {t("App.buttonLabels.accept")}
              </Button>
            </div>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalInfo;
